import { useEffect, useRef, useState, useContext } from 'react';
import styles from './Filter.module.css'
import { filterDTO, valueModel } from '../../types';
import SelectBox from "../../../SelectBox/SelectBox";
import axios, { AxiosRequestConfig } from 'axios';
import { Col, Row } from 'reactstrap';
import { FilterContext } from '../FilterContext';
import TextBox from "../../../TextBox/Textbox";


//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import MultipleSelectBox, { mapToMultipleSelectBoxModal } from '../../../MultipleSelectBox/MultipleSelectBox';
import { activeFiltersToString, convertDateToIso, getVariableValue } from '../FilterFormFunctions';
import useDebounce from 'src/hooks/useDebounce';

async function getFilterData(getFilterUrl: string, columnName: string): Promise<valueModel[] | never[]> {
    const data = JSON.parse(localStorage.getItem(`${process.env.REACT_APP_BASENAME}_authUser`) || '{}');
    const token = data.token || "";

    const header: AxiosRequestConfig = {headers: {"Authorization": "Bearer " + token}}

    return await axios.get<filterDTO[]>(getFilterUrl + columnName, header)
        .then((response) => {
            return response.data[0].filterSelectValues;
        }).catch ((error) => {
            console.log(error);
            return []
        })
}

    
function Filter({
    data,
    isOpen,
    setActiveFilterTab,
    filterNumber
}: {
    data: filterDTO;
    isOpen: boolean;
    setActiveFilterTab: () => void;
    filterNumber: number;
}) {
    const contentRef = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState(0);
    const [filterData, setFilterData] = useState<filterDTO>();
    const [isOperatorSelectorActive, setIsOperatorSelectorActive] = useState(true);
    

    const currentFilterContext = useContext(FilterContext);

    const [localFilterData, setLocalFilterData] = useState<filterDTO[] | undefined>(currentFilterContext.filterData);
    const debouncedFilterData = useDebounce<filterDTO[] | undefined>(localFilterData, 300); // Adjust the delay as needed

    useEffect(() => {
        if (debouncedFilterData) {
        currentFilterContext.setFilterData(debouncedFilterData);
        }
    }, [debouncedFilterData]);

    const getFilterUrl = currentFilterContext.filterUrl;

    function onChangeComparisonAndLogicalOperator(id: string, operatorID: string, currentfilterNumber: number) {
        let filterDataCopy: filterDTO = {...data};
        let filtersArrayDataCopy: filterDTO[] = []

        if(currentFilterContext.filterData){
            filtersArrayDataCopy = currentFilterContext.filterData;
        }

        if (filterDataCopy.columnName == id) {
            filterDataCopy.operatorID = +operatorID;
            if (filterDataCopy.operatorID == 12 || filterDataCopy.operatorID == 13) {
                getFilterData(getFilterUrl, data.columnName).then(res => {
                    filterDataCopy.filterSelectValues = res
                });
            }
            filtersArrayDataCopy[currentfilterNumber] = filterDataCopy;
            currentFilterContext.setFilterData(filtersArrayDataCopy);
            setFilterData(filterDataCopy);
        }
    }

    function onInputTextBox(newValue: string, filter: filterDTO, userValueArrayPosition: number = 0) {
        let filterDataCopy: filterDTO[] = [];
        if(currentFilterContext.filterData){
            filterDataCopy = [...currentFilterContext.filterData];
        }
        const filterIndex = filterDataCopy.findIndex(( (tmpFilter: filterDTO) => tmpFilter.columnName == filter.columnName));

        if (filterDataCopy[filterIndex].userValues == undefined) {
            filterDataCopy[filterIndex]["userValues"] = [];
        }

        if (userValueArrayPosition > 0) {
            for (let i = 0; i < userValueArrayPosition; i++) {
                if (!filterDataCopy[filterIndex].userValues[i]) {
                    filterDataCopy[filterIndex].userValues[i] = "";
                }
            }
        }

        filterDataCopy[filterIndex].userValues[userValueArrayPosition] = newValue
        setLocalFilterData(filterDataCopy);
    }

    const getOptionsFlatpickr = (defaultDate: string[], position: number) => {
        //console.log("Array.isArray(defaultDate)", Array.isArray(defaultDate), "defaultDate[position] != undefined", defaultDate[position] != undefined)
        if (Array.isArray(defaultDate) && defaultDate[position] != undefined) {
            return {
                allowInput: true,
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
                defaultDate: defaultDate[position]
            }
        } else {
            return {
                allowInput: true,
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
                defaultDate: ""
            }
        }
    }

    function onInputDatePicker(newValue: string, filter: filterDTO, userValueArrayPosition: number = 0) {
        let filterDataCopy: filterDTO[] = [];

        if (currentFilterContext.filterData){
            filterDataCopy = [...currentFilterContext.filterData];
        }

        const filterIndex = filterDataCopy.findIndex(((tmpFilter: filterDTO) => tmpFilter.columnName == filter.columnName));

        if (filterDataCopy[filterIndex].userValues == undefined) {
            filterDataCopy[filterIndex]["userValues"] = [];
        }

        if (userValueArrayPosition > 0) {
            for (let i = 0; i < userValueArrayPosition; i++) {
                if (!filterDataCopy[filterIndex].userValues[i]) {
                    filterDataCopy[filterIndex].userValues[i] = "";
                }
            }
        }

        filterDataCopy[filterIndex].userValues[userValueArrayPosition] = convertDateToIso(newValue)
        setLocalFilterData(filterDataCopy);
    }

    function onChangeBoolean(id: string, value: string) {
        let filterDataCopy: filterDTO[] = [];

        if (currentFilterContext.filterData){
            filterDataCopy = [...currentFilterContext.filterData];
        }

        filterDataCopy.map((data: filterDTO, index: number) => {
            if (data.columnName == id) {
                data.userValues = [value];
                filterDataCopy[index] = data;

                setLocalFilterData(filterDataCopy);
                return;
            }
        })
    }

    function mapFromMultipleSelectBoxModel(items: { value: number, label: string }[]): valueModel[] {
        if (items) {
            return items.map(item => {
                return {
                    id: item.value, 
                    value: item.label,
                }
            })
        } else {
            return []
        }
      }

    function onChangeMultipleSelectBox(selectedValue: any[], noneSelectedValue: any[], filter: filterDTO) {
        let filterDataCopy: filterDTO[] = [];

        if (currentFilterContext.filterData){
            filterDataCopy = [...currentFilterContext.filterData];
        }

        const filterIndex = filterDataCopy.findIndex(((tmpFilter: filterDTO) => tmpFilter.columnName == filter.columnName));

        filterDataCopy[filterIndex]["userValues"] = [];
        filterDataCopy[filterIndex]["filterSelectValues"] = [];
        filterDataCopy[filterIndex].filterSelectValues = noneSelectedValue;
        filterDataCopy[filterIndex].userValues = selectedValue;
        setLocalFilterData(filterDataCopy);
    }

    function printFilter(filter: filterDTO) {
        if (filter) {
            switch (filter.operatorID) {
                case(-1):
                    return <></>
                case(10):
                case(11):
                    return (
                        <>
                            {filter.typeUI == "textbox" &&
                                    <Row>
                                        <Col xs={6}>
                                            <TextBox 
                                                field={filter.columnName + "Start"}
                                                value={getVariableValue(filter.userValues, 0)}
                                                onChangeValue={(val: string) => {
                                                    onInputTextBox(val, filter, 0)
                                                }}
                                            />
                                        </Col>
                                        <Col xs={6}>
                                            <TextBox 
                                                field={filter.columnName + "End"}
                                                value={getVariableValue(filter.userValues, 1)}
                                                onChangeValue={(val: string) => {
                                                    onInputTextBox(val, filter, 1)
                                                }}
                                            />
                                        </Col>
                                    </Row>
                            }
                            {filter.typeUI == "datepicker" &&
                                <Row>
                                    <Col xs={6}>
                                        <Flatpickr
                                            className="form-control d-block"
                                            placeholder="YYYY-MM-DD"
                                            options={getOptionsFlatpickr(filter.userValues, 0)}
                                            name={filter.columnName + "Start"}
                                            onChange={(date: string) => {
                                                onInputDatePicker(date, filter, 0)
                                            }}
                                        />
                                    </Col>
                                    <Col xs={6}>
                                        <Flatpickr
                                            className="form-control d-block"
                                            placeholder="YYYY-MM-DD"
                                            options={getOptionsFlatpickr(filter.userValues, 1)}
                                            name={filter.columnName + "End"}
                                            onChange={(date: string) => {
                                                onInputDatePicker(date, filter, 1)
                                            }}
                                        />
                                    </Col>
                                </Row>
                            }
                        </>
                    )
                case(12):
                case(13):
                    return (
                        <>
                            {/* Multiple select box */}
                            <div style={{minHeight: "300px"}}>
                                <MultipleSelectBox 
                                    nonSelected={mapToMultipleSelectBoxModal(filter.filterSelectValues)}
                                    selected={mapToMultipleSelectBoxModal(filter.userValues)}
                                    onChange={(selected, nonSelected) => {
                                        onChangeMultipleSelectBox(mapFromMultipleSelectBoxModel(selected), mapFromMultipleSelectBoxModel(nonSelected), filter);
                                    }}
                                />
                            </div>
                        </>
                    )
                default:
                    return (
                        <Row>
                            {filter.typeUI == "textbox" &&
                                <Col xs={12}>
                                    <TextBox field={filter.columnName + "Start"}
                                             value={getVariableValue(filter.userValues, 0)}
                                             onChangeValue={(val: string) => {
                                                 onInputTextBox(val, filter, 0);
                                             }}/>
                                </Col>
                            }
                            {filter.typeUI == "datepicker" &&
                                <Col xs={12}>
                                    <Flatpickr
                                        className="form-control d-block"
                                        placeholder="YYYY-MM-DD"
                                        options={getOptionsFlatpickr(filter.userValues, 0)}
                                        name={filter.columnName}
                                        onChange={(date: string) => {
                                            onInputDatePicker(date, filter, 0)
                                        }}
                                        
                                    />
                                </Col>
                            }
                            {filter.typeUI == "boolean" &&
                                <Col xs={12}>
                                    <SelectBox 
                                        field={filter.columnName} 
                                        displayName={filter.displayName}
                                        options={filter.filterSelectValues}
                                        selectedId={filter.userValues ? filter.userValues[0] : -1}
                                        firstOption="Select"
                                        onChangeOperator={(selected: string) => {
                                            onChangeBoolean(filter.columnName, selected)
                                        }}
                                    />
                                </Col>
                            }

                        </Row>
                    )
            }
        }
    }

    useEffect(() =>{
        setFilterData(data)
        if(data){
            if(data.validOperatorIDs.length == 1 && data.typeUI == "MultiSelectBox"){
                setIsOperatorSelectorActive(false);
            }
        }
    },[currentFilterContext.filterData])
    
    useEffect(() => {
        
        if (isOpen) {
            const contentEl: HTMLDivElement | null = contentRef.current;
            if(contentEl){
                setHeight(contentEl.scrollHeight);
            }  
        } else {
            setHeight(0);
        }
    }, [isOpen, filterData]);

  return (
    <li className={`${styles["accordion-item"]} ${isOpen ? styles["active"] : ''}`}>
        <h2 className={`${styles["accordion-item-title"]}`}>
            <button className={`${styles["accordion-item-btn"]}`} onClick={setActiveFilterTab}>
                <span className='d-flex flex-column'>
                    <span>{filterData?.displayName}</span>
                    <span className='text-secondary'>{activeFiltersToString(filterData?.typeUI, filterData?.userValues, filterData?.filterSelectValues)} </span> 
                </span>
            </button>
        </h2>
        <div className={`${styles["accordion-item-container"]} operator-${filterData?.operatorID}`} style={{ height }}>
            <div ref={contentRef} className={`${styles["accordion-item-content"]}`}>
                {filterData &&
                    <Row>
                        {isOperatorSelectorActive && 
                            <Col xs={4}>
                                <SelectBox 
                                    field={filterData.columnName} 
                                    displayName={filterData.displayName}
                                    options={filterData.transformedValidOperators}
                                    selectedId={filterData.operatorID} firstOption="Operator"
                                    onChangeOperator={(selected: string) => {
                                        onChangeComparisonAndLogicalOperator(filterData.columnName, selected, filterNumber)
                                    }}
                                />
                            </Col>
                        }
                
                        <Col xs={isOperatorSelectorActive ? 8 : 12}>
                           {printFilter(filterData)}
                        </Col>
                    </Row>
                    
                }
            </div>
        </div>
    </li>
  );
}

export default Filter;